import { render } from "./QuoteContent.vue?vue&type=template&id=33e97022&scoped=true&ts=true"
import script from "./QuoteContent.vue?vue&type=script&lang=ts"
export * from "./QuoteContent.vue?vue&type=script&lang=ts"

import "./QuoteContent.vue?vue&type=style&index=0&id=33e97022&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e97022"]])

export default __exports__